export default "/img/icon-personal-use.svg"